/**
 * Define a pluralization method
 * @param pluralization - Pluralization
 * @returns Pluralization
 * @__NO_SIDE_EFFECTS__
 */
export function definePluralization(pluralization) {
    return pluralization;
}
//# sourceMappingURL=pluralization.js.map